import { REMOVE_USERS_DETAILS, SET_USERS_DETAILS } from '../Constants';

export const setUserLoginDetails = (value) => async (dispatch) => {
  dispatch({ type: SET_USERS_DETAILS, payload: value });
};

export const removeUserLoginDetails = () => async (dispatch) => {
  dispatch({ type: REMOVE_USERS_DETAILS, payload: null });
};
